var path = '/var/www/mmscny-cms/src/app/common/components/feature-main-page-template/new-menu-add/new-menu-add.html';
var html = "<div class=new-menu-add-modal> <form novalidate=novalidate ng-submit=$ctrl.onSubmit()> <div class=new-menu-modal_header> <div class=title> <span>Add New Menu</span> </div> <div class=close_modal ng-click=$ctrl.close()> <span>X</span> </div> </div> <div class=new-menu-modal_body> <overview-template details=$ctrl.details disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.close() on-submit=$ctrl.onSubmit() is-description-available={{true}}> </overview-template> </div> <div class=new-menu-modal_footer> </div> </form> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/feature-main-page-template/new-menu-add/new-menu-add.html
// module id = 726
// module chunks = 0